package com.gsb.vyapar.bhagya.presentation.navigation.view

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material.BottomNavigation
import androidx.compose.material.Scaffold
import androidx.compose.material.Text
import androidx.compose.material.rememberScaffoldState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.composable
import androidx.navigation.compose.rememberNavController
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.launchDefault
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.interactor.util.hideLoading
import com.gsb.vyapar.bhagya.interactor.util.showLoading
import com.gsb.vyapar.bhagya.presentation.Screens.*
import com.gsb.vyapar.bhagya.presentation.admin.view.*
import com.gsb.vyapar.bhagya.presentation.auth.view.*
import com.gsb.vyapar.bhagya.presentation.business.util.launchBusinessDetail
import com.gsb.vyapar.bhagya.presentation.business.view.*
import com.gsb.vyapar.bhagya.presentation.category.add.view.AddCategoryView
import com.gsb.vyapar.bhagya.presentation.category.view.*
import com.gsb.vyapar.bhagya.presentation.common.animation.Animate
import com.gsb.vyapar.bhagya.presentation.search.view.SearchView
import com.gsb.vyapar.bhagya.presentation.searchlist.view.SearchListView
import com.gsb.vyapar.bhagya.theme.*
import com.gsb.vyapar.bhagya.util.BuildConfig
import com.gsb.vyapar.bhagya.util.PlatformType
import com.gsb.vyapar.bhagya.util.getBusinessIdFromUrl
import kotlinx.coroutines.delay

@Composable
fun NavigationView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    Box(Modifier.fillMaxSize()) {
        val navController = rememberNavController()
        val scaffoldState = rememberScaffoldState()
        val scope = rememberCoroutineScope()
        var isHomeMapInteracting by remember { mutableStateOf(false) }
        LaunchedEffect(uiState.isPortrait) {
            scaffoldState.drawerState.close()
        }
        LaunchedEffect(uiState.navView) {
            if (uiState.navView != null) {
                scaffoldState.drawerState.close()
                isHomeMapInteracting = false
            }
        }
        Scaffold(
            scaffoldState = scaffoldState,
            topBar = {
                if (uiState.navView == null) NavigationTopBar(uiState, navController, scaffoldState, scope)
            },
            drawerGesturesEnabled = uiState.navView == null && !isHomeMapInteracting,
            drawerBackgroundColor = Color.Transparent,
            drawerContentColor = Color.Transparent,
            drawerScrimColor = Color.Transparent,
            drawerElevation = 0.dp,
            drawerContent = {
                if (uiState.navView == null) NavigationDrawerView(uiState, onTriggerEvent, navController, scaffoldState, scope)
            },
            bottomBar = {
                if (uiState.navView == null) {
                    BottomNavigation(backgroundColor = primary) {
                        NavigationItem(Home, navController)
                        NavigationItem(Categories, navController)
                        NavigationItem(Latest, navController)
                        NavigationItem(Favorites, navController)
                    }
                }
            }
        ) {
            NavHost(
                navController, startDestination = Home.toString(), modifier = Modifier
                    .background(color = navbackground)
                    .padding(it)
            ) {
                composable(Home.toString()) {
                    HomeView(
                        uiState = uiState,
                        onTriggerEvent = onTriggerEvent,
                        onMapInteractionChanged = { isHomeMapInteracting = it }
                    )
                }
                composable(Categories.toString()) {
                    CategoriesView(uiState, onTriggerEvent)
                }
                composable(Latest.toString()) {
                    LatestBusinessView(uiState, onTriggerEvent)
                }
                composable(Favorites.toString()) {
                    FavoritesBusinessView(uiState, onTriggerEvent)
                }
            }
            uiState.navView?.let {
                when (uiState.navView) {
                    Category ->  Animate { CategoryView(uiState, onTriggerEvent) }
                    AddCategory ->  Animate { AddCategoryView(uiState, onTriggerEvent) }
                    AdminCategories ->  Animate { AdminCategoriesView(uiState, onTriggerEvent) }
                    InfoScreen ->  Animate { InfoView(uiState, onTriggerEvent) }
                    ConfigScreen ->  Animate { ConfigView(uiState, onTriggerEvent) }
                    Login -> Animate { LoginView(uiState, onTriggerEvent) }
                    Register -> Animate { RegisterView(uiState, onTriggerEvent) }
                    About -> Animate { AboutView(uiState, onTriggerEvent) }
                    ManageBusiness -> Animate { ManageBusinessView(uiState, onTriggerEvent) }
                    AddEditBusiness -> Animate { AddEditBusinessView(uiState, onTriggerEvent) }
                    AdminView -> Animate { AdminView(uiState, onTriggerEvent) }
                    ReviewBusiness -> Animate { ReviewView(uiState, onTriggerEvent) }
                    BusinessDetail -> Animate { BusinessDetailView(uiState, onTriggerEvent) }
                    BusinessMap -> Animate { FullScreenBusinessMapView(uiState, onTriggerEvent) }
                    Search -> Animate { SearchView(uiState, onTriggerEvent) }
                    Gallery -> Animate { FullScreenImageViewer(uiState, onTriggerEvent) }
                    PasswordLogin -> Animate { LoginWithPasswordView(uiState, onTriggerEvent) }
                    GetUser -> Animate { GetUserView(uiState, onTriggerEvent) }
                    SearchList -> Animate { SearchListView(uiState, onTriggerEvent) }
                    else -> Text("UnKnown View")
                }
            }
            PlatformBackHandler(uiState, onTriggerEvent)
        }
    }
    LaunchedEffect(Unit) {
        if (BuildConfig.platform() == PlatformType.JS || BuildConfig.platform() == PlatformType.WASM) {
            getBusinessIdFromUrl(uiState.deepLink)?.let {
                launchDefault {
                    showLoading()
                    delay(2000)
                    launchBusinessDetail(it)
                    hideLoading()
                }
            }
        }
    }
}
